import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { Modal, Button, EButtonType, PromptWindow } from "@fhx/ui";
import styles from "./DownloadEntryFooter.module.scss";
import i18n from "../../DownloadEntryWindow.i18n";
import { IDownloadableContent } from "../../../../../../../../interfaces";

export interface IProps {
  entry: IDownloadableContent;
}

export default function DownloadEntryFooter({ entry }: IProps): React.ReactElement {
  const { formatMessage } = useIntl();
  const { urls, isDownloadDisabled, filesizeMb, md5Checksum, sha1Checksum } = entry;
  const [modalContent, setModalContent] = useState<React.ReactNode>("");
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const handleOnClickMd5Checksum = useCallback((): void => {
    setModalContent(
      <>
        <h4>{formatMessage(i18n.md5Checksum)}</h4>
        <div className={styles.userSelect}>{md5Checksum}</div>
      </>,
    );
    setIsModalVisible(true);
  }, [formatMessage, md5Checksum]);

  const handleOnClickSha1Checksum = useCallback((): void => {
    setModalContent(
      <>
        <h4>{formatMessage(i18n.sha1Checksum)}</h4>
        <div className={styles.userSelect}>{sha1Checksum}</div>
      </>,
    );
    setIsModalVisible(true);
  }, [formatMessage, sha1Checksum]);

  return (
    <>
      {isModalVisible && (
        <Modal>
          <PromptWindow onSubmit={(): void => setIsModalVisible(false)} className={styles.modalWindow}>
            {modalContent}
          </PromptWindow>
        </Modal>
      )}
      <>
        {isDownloadDisabled && <div className={styles.downloadDisabled}>{formatMessage(i18n.downloadIsDisabled)}</div>}
        {!isDownloadDisabled && (
          <>
            {filesizeMb && <div className={styles.fileSize}>~{filesizeMb} MB</div>}
            {md5Checksum && (
              <Button type={EButtonType.GUILD_BASE1_116X17} onClick={handleOnClickMd5Checksum}>
                {formatMessage(i18n.md5Checksum)}
              </Button>
            )}
            {sha1Checksum && (
              <Button type={EButtonType.GUILD_BASE1_116X17} onClick={handleOnClickSha1Checksum}>
                {formatMessage(i18n.sha1Checksum)}
              </Button>
            )}

            <Button
              type={EButtonType.CN_192X32}
              onClick={(): void => {
                window.open(urls[0], "_self");
              }}
            >
              {formatMessage(i18n.download)}
            </Button>
          </>
        )}
      </>
    </>
  );
}
